module.exports = __webpack_public_path__ + "static/scale-model-of-hampton-virginia-704a0f4af0dcad48161f925764b3b3bf.png";